import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default (props) => {
  const { pathname } = useLocation();
  const changedPathRef = useRef(props.changedPath);

  // Keep ref updated
  useEffect(() => {
    changedPathRef.current = props.changedPath;
  }, [props.changedPath]);

  useEffect(() => {
    if (changedPathRef.current) {
      changedPathRef.current(pathname);
    }
  }, [pathname]);

  return null;
};
